import { inject, Injectable } from '@angular/core';
import { MarginExpensesStore } from '../margin-expenses/margin-expenses.store';
import { MarginExpenseType } from '../../models/margin-expense-type.model';
import { tapResponse } from '@ngrx/operators';
import { take, switchMap } from 'rxjs/operators';
import { MarginExpensesService } from '../../services/margin-expenses.service';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { FacilityExpenseCaps } from 'src/app/shared/models/facility-expense-caps.model';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';
import { rxMethod } from '@ngrx/signals/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class MarginExpensesEffects {
    private readonly marginExpensesStore = inject(MarginExpensesStore);
    private readonly marginExpensesService = inject(MarginExpensesService);
    private readonly eventBus = inject(EventBusService);

    constructor() {
        this.listenToMarginExpenseDependencies();
    }

    getMarginExpenseTypes(): void {
        this.marginExpensesService
            .getMarginExpensesTypes()
            .pipe(
                take(1),
                tapResponse({
                    next: (data: MarginExpenseType[]) => {
                        this.marginExpensesStore.getMarginExpenseTypes(data);
                    },
                    error: () => {
                        this.marginExpensesStore.getMarginExpenseTypes([]);
                    }
                })
            )
            .subscribe();
    }

    readonly getExpenseCapsByFacilityId = rxMethod<number>((facilityId$) =>
        facilityId$.pipe(
            switchMap((facilityId: number) =>
                this.marginExpensesService.getExpenseCapsByFacilityId(facilityId).pipe(
                    take(1),
                    tapResponse({
                        next: (data: FacilityExpenseCaps[]) => {
                            this.marginExpensesStore.getExpenseCaps(data);
                        },
                        error: () => {
                            this.marginExpensesStore.getExpenseCaps([]);
                        }
                    })
                )
            )
        )
    );

    listenToMarginExpenseDependencies(): void {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.JOB_DETAILS_LOADED)
            .pipe(take(1))
            .subscribe((event: EventPayload) => {
                this.getExpenseCapsByFacilityId(event.payload.facilityId);
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .pipe(take(1))
            .subscribe((event: EventPayload) => {
                this.getExpenseCapsByFacilityId(event.payload.marginDetails.jobDetails.facilityId);
            });
    }
}
